import Body from '@actr/dev-presets/client/layout/body';
import Head from '@actr/dev-presets/client/layout/head';
import Html from '@actr/dev-presets/client/layout/html';
import { ProjectTypes } from '@actr/specs/src/project/types';
import {
  getHtmlThemeAttributes
} from '@actr/style/src/themes';
import React from 'react';
import App from 'Root/App';

import config from './configs';

const Layout = () => {
  function getFaviconPath() {
    switch (config.projectType) {
      case ProjectTypes.VTB: return '/favicon-vtb.ico';
      case ProjectTypes.NORDSTAR: return '/favicon-nordstar.ico';
      case ProjectTypes.SMARTFLIGHT: return '/favicon-smartflight.ico';
      case ProjectTypes.KEY_TRAVEL: return '/favicon-keytravel.ico';
      case ProjectTypes.OTELLO: return '/favicon-otello.ico';
      case ProjectTypes.WEBVIEW:
      case ProjectTypes.SKB:
      case ProjectTypes.AK_REDESIGN: return '/favicon.ico';
      default: return '/faviconpp.ico';
    }
  }

  function getPageTitle() {
    switch (config.projectType) {
      case ProjectTypes.WEBVIEW:
      case ProjectTypes.AK_REDESIGN: return 'Поиск дешевых авиабилетов онлайн, авиабилеты дешево на сайте Авиакасса, '
          + 'купить билет на самолет, стоимость авиабилетов';
      case ProjectTypes.SMARTFLIGHT: return 'Find great deals';
      default: return 'Поиск выгодных предложений';
    }
  }

  return (
    <Html {...getHtmlThemeAttributes(config.theme)}>
      <Head
        title={getPageTitle()}
        faviconPath={getFaviconPath()}>
        {config.projectType === ProjectTypes.AK_REDESIGN && (<link rel="manifest" href="/manifest.json" crossOrigin="use-credentials" />)}
        {/* Данные перехода с меты нужны до старта приложения, поэтому код остаётся в теле тега */}
        <script
          data-actr-bundle-placement="inline"
          src="@actr/utilities/src/url/channel-data/fallback-meta.ts"
        />
      </Head>
      <Body>
        <App />
        <div id="modal-container" />
        <div id="popover-container" />
      </Body>
    </Html>
  );
};

export default Layout;
